export { default as getTargetMonths } from './getTargetMonths';
